import { Chip, Popover } from '@mui/material';
import React from 'react';
import { SIZES } from '../../../../constants/constants';
import { V } from '../../../../Layout';
import type { MultiSelectChipsOverflowListProps } from '../../types';
import { useMultiSelectChipsOverflowPopover } from '../hooks/useMultiSelectChipsOverflowPopover';
import {
    OVERFLOW_MORE_CHIP_SX,
    OVERFLOW_POPOVER_ANCHOR_ORIGIN,
    OVERFLOW_POPOVER_CONTENT_SX,
    OVERFLOW_POPOVER_TRANSFORM_ORIGIN
} from '../utils';
import { MultiSelectChipsOverflowListItem } from './MultiSelectChipsOverflowListItem';

export function MultiSelectChipsOverflowList({
    overflow,
    onRemove,
    readOnly = false,
    stopOverflowPropagation = false
}: MultiSelectChipsOverflowListProps) {
    const { moreAnchorEl, handleMoreClick, handleMoreClose, stopPropagation } = useMultiSelectChipsOverflowPopover({
        stopOverflowPropagation
    });

    if (overflow.length === 0) {
        return null;
    }

    const overflowLabel = `+${overflow.length}`;
    const isPopoverOpen = Boolean(moreAnchorEl);
    const popoverSlotProps = stopOverflowPropagation
        ? {
              paper: {
                  onMouseDown: stopPropagation,
                  onClick: stopPropagation
              }
          }
        : undefined;

    return (
        <>
            <Chip
                label={overflowLabel}
                size={SIZES.small}
                color="default"
                variant="filled"
                component="button"
                type="button"
                sx={OVERFLOW_MORE_CHIP_SX}
                onClick={handleMoreClick}
            />
            <Popover
                open={isPopoverOpen}
                anchorEl={moreAnchorEl}
                onClose={handleMoreClose}
                anchorOrigin={OVERFLOW_POPOVER_ANCHOR_ORIGIN}
                transformOrigin={OVERFLOW_POPOVER_TRANSFORM_ORIGIN}
                slotProps={popoverSlotProps}
            >
                <V sx={OVERFLOW_POPOVER_CONTENT_SX}>
                    {overflow.map((value, index) => (
                        <MultiSelectChipsOverflowListItem
                            key={`overflow-${index}`}
                            value={value}
                            onRemove={onRemove}
                            readOnly={readOnly}
                            stopOverflowPropagation={stopOverflowPropagation}
                        />
                    ))}
                </V>
            </Popover>
        </>
    );
}
